import React from 'react'
import PropTypes from 'prop-types'
import { GalleryBlock, GalleryMain } from './index.style'
import { GatsbyImage } from 'gatsby-plugin-image'

const Gallery = ({ images, largeFirst }) => {
  const largeIndex = largeFirst ? 0 : 1
  return (
    <GalleryMain>
      {React.Children.toArray(
        images.map((image, imageIndex) => (
          <GalleryBlock large={imageIndex === largeIndex}>
            <GatsbyImage
              image={image.gatsbyImageData}
              alt={image.description}
            />
          </GalleryBlock>
        ))
      )}
    </GalleryMain>
  )
}

Gallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.object),
  largeFirst: PropTypes.bool,
}

export default Gallery
